@if (config) {
  <div class="ClaimsSubmission__Instructions">
    <div class="ClaimsSubmission__Layout">
      <h4 class="ClaimsSubmission__Heading">{{ config.body?.heading }}</h4>
      <div class="t-html ClaimsSubmission__Details">
        @if (config.body?.infoPanelConfig; as infoConfig) {
          <section>
            @if (infoConfig?.header) {
              <div class="ClaimsSubmission__Header">
                <h6>{{ infoConfig.header }}</h6>
              </div>
            }
            @for (item of infoConfig?.items; track item) {
              @if (item?.headerLabel) {
                <div class="ClaimsSubmission__ItemHeader">
                  @if (item?.headerIcon) {
                    @if (item.headerIcon !== 'info') {
                      <div class="ClaimsSubmission__Content">
                        <icon
                          class="ClaimsSubmission__Icon"
                          [name]="item.headerIcon"
                        >
                        </icon>
                        <p
                          class="t-data ClaimsSubmission__Label"
                          [ngClass]="{ 't-bold': isMobileView }"
                        >
                          {{ item.headerLabel }}
                        </p>
                      </div>
                    } @else {
                      @if (!isMobileView) {
                        <div class="ClaimsSubmission__Content">
                          <icon
                            class="ClaimsSubmission__Icon"
                            [name]="item.headerIcon"
                          >
                          </icon>
                          <p class="t-data t-bold ClaimsSubmission__Label">
                            {{ item.headerLabel }}
                          </p>
                        </div>
                      }
                    }
                  } @else {
                    <ul class="ClaimsSubmission__List">
                      <li class="ClaimsSubmission__ListItem">
                        {{ item.headerLabel }}
                      </li>
                    </ul>
                  }
                </div>
              }
              @for (field of item.fields; track field) {
                @if (field.type === types.TEXT) {
                  <div class="ClaimsSubmission__ItemContent">
                    @if (field.icon) {
                      <icon [name]="field.icon"> </icon>
                    }
                    <p
                      class="t-data ClaimsSubmission__Label"
                      [ngClass]="{ 't-bold': field.isFontBold }"
                    >
                      {{ field.label }}
                    </p>
                  </div>
                }
              }
            }
          </section>
        }
      </div>
    </div>
    <footer class="ClaimsSubmission__Footer">
      <div class="ClaimsSubmission__ClaimsButtons container">
        <zip-button
          class="ClaimsSubmission__CancelButton ClaimsSubmission__ClaimsButton"
          [config]="config?.footer?.cancel"
          (click)="cancel()"
          data-test-id="claimSubmissionCancelButton"
        ></zip-button>
        <zip-button
          class="ClaimsSubmission__ContinueButton ClaimsSubmission__ClaimsButton"
          [config]="config?.footer?.continue"
          (click)="continue()"
          data-test-id="claimSubmissionContinueButton"
        ></zip-button>
      </div>
    </footer>
  </div>
}
